export type IAppInfoState = {
	frontEnd: string;
	backEnd: string;
	loading: boolean;
	loaded: boolean;
	indicators: {
		isPwaInstalled: boolean;
	};
};

export const appInfoInitialState: IAppInfoState = {
	frontEnd: '',
	backEnd: '',
	loading: false,
	loaded: false,
	indicators: {
		isPwaInstalled: false,
	},
};
